import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_MSAL_TANENT_ID}`,
    redirectUri: process.env.REACT_APP_MSAL_REDIRECT_URI,
  },
};

export const pca = new PublicClientApplication(msalConfig);
